import classNames from 'classnames';
import { ReactNode } from 'react';

interface FormLayoutProps {
  children: ReactNode;
  className?: string;
}

export const FormLayout = ({ children, className }: FormLayoutProps) => (
  <div className={classNames('mx-auto flex w-full flex-col gap-5 text-left', className)}>
    {children}
  </div>
);
